var NOT_APPLICABLE = -1;

function statValue(batchStats, field) {
	if (!batchStats) {
		return NOT_APPLICABLE;
	}
	var value = batchStats[field];
	if (value === undefined || value === null) {
		return NOT_APPLICABLE;
	}
	return value;
}

function isApplicable(value) {
	return value !== undefined && value !== null && value >= 0;
}

function ratioLine(label, numerator, denominator) {
	if (!isApplicable(numerator)) {
		return '';
	}
	if (isApplicable(denominator) && denominator > 0) {
		return label + ': ' + numerator + ' / ' + denominator;
	}
	return label + ': ' + numerator;
}

function importStoragePhase(batchStats) {
	var detail = batchStats.detailStatus ? batchStats.detailStatus : '';
	if (detail.indexOf('Store Data') >= 0
		|| detail.indexOf('Finalize Import') >= 0
		|| detail.indexOf('Storing Unit Data') >= 0) {
		return true;
	}
	var completedStages = statValue(batchStats, 'completedStages');
	return isApplicable(completedStages) && completedStages >= 2;
}

function formatImportQuickStats(batchStats) {
	var dataCount = statValue(batchStats, 'dataCount');
	var recordCount = statValue(batchStats, 'recordCount');
	var storedCount = statValue(batchStats, 'storedCount');
	if (importStoragePhase(batchStats)) {
		return ratioLine('Records Stored', storedCount, recordCount);
	}
	return ratioLine('Read', dataCount, recordCount);
}

var METRIC_LABELS = {
	'import.storageUnitsTotal': 'Storage Units Total',
	'import.storageUnitsComplete': 'Storage Units Complete',
	'delete.unitsTotal': 'Units Total',
	'delete.unitsComplete': 'Units Complete',
	'fuel.unmatched': 'Unmatched Fuel',
	'rollback.recordsDeleted': 'Records Deleted',
	'restore.unitsAffected': 'Units Affected',
	'purge.unitsAffected': 'Units Affected',
	'merge.gpsRecordsMoved': 'GPS Records Moved',
	'merge.fuelRecordsMoved': 'Fuel Records Moved',
	'merge.tripRecordsMoved': 'Trip Records Moved',
	'merge.idleRecordsMoved': 'Idle Records Moved',
	'merge.distanceSummaryRecordsMoved': 'Distance Summary Records Moved',
	'archive.gpsRecords': 'GPS Records',
	'archive.fuelRecords': 'Fuel Records',
	'archive.tripRecords': 'Trip Records',
	'archive.idleRecords': 'Idle Records',
	'archive.distanceSummaryRecords': 'Distance Summary Records'
};

function formatQuickStatsLine2(batchTaskType, batchStats, split) {
	if (!batchStats) {
		return '';
	}

	switch (batchTaskType) {
		case 'IMPORT_PROCESS':
			return formatImportQuickStats(batchStats);
		case 'CALCULATION':
			if (split) {
				return ratioLine('Work Tasks', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
			}
			return ratioLine('Units Processed', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'REPORT':
			if (isApplicable(statValue(batchStats, 'totalCount'))) {
				return 'Units In Report: ' + statValue(batchStats, 'totalCount');
			}
			return '';
		case 'BULK_GROUP_REPORTS':
			return ratioLine('Groups Complete', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'CLOSE_REPORTS':
			return ratioLine('Reports Complete', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'DELETE_DATA':
			return ratioLine('Records Deleted', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'GPS_FILTER':
		case 'TIME_SHIFT':
		case 'REMOVE_TRACTORS':
		case 'REMOVE_TRAILERS':
		case 'REMOVE_DRIVERS':
			return ratioLine('Units Processed', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'MATCH_UNREFERENCE_FUEL':
			return ratioLine('Matched', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'ROLLBACK_IMPORT':
			return ratioLine('Units Processed', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'RESTORE_DELETED_DATA':
			if (isApplicable(statValue(batchStats, 'dataCount'))) {
				return 'Restored: ' + statValue(batchStats, 'dataCount');
			}
			return '';
		case 'HARD_PURGE_DELETED_DATA':
			if (isApplicable(statValue(batchStats, 'dataCount'))) {
				return 'Purged: ' + statValue(batchStats, 'dataCount');
			}
			return '';
		case 'ARCHIVE':
		case 'ARCHIVE_RESTORE':
			return ratioLine('Units Processed', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
		case 'MERGE_TRACTORS':
		case 'TEST':
		case 'V6_MIGRATION':
		case 'V6_MIGRATION_FINALIZE':
			return '';
		default:
			return legacyQuickStats(batchStats, split);
	}
}

function legacyQuickStats(batchStats, split) {
	if (split) {
		return ratioLine('Work Tasks', statValue(batchStats, 'dataCount'), statValue(batchStats, 'totalCount'));
	}
	var totalCount = statValue(batchStats, 'totalCount');
	var totalStages = statValue(batchStats, 'totalStages');
	if (isApplicable(totalCount) && totalCount > 0) {
		return ratioLine('Progress', statValue(batchStats, 'dataCount'), totalCount);
	}
	if (isApplicable(totalStages) && totalStages > 0) {
		return '';
	}
	return '';
}

function formatStatsGridHtml(batchTaskType, batchStats, split) {
	if (!batchStats) {
		return '';
	}
	var completedStages = statValue(batchStats, 'completedStages');
	if (!isApplicable(completedStages)) {
		completedStages = 0;
	}
	var totalStages = statValue(batchStats, 'totalStages');
	if (!isApplicable(totalStages)) {
		totalStages = 0;
	}
	var line1 = completedStages + ' / ' + totalStages + ' Stages';
	var line2 = formatQuickStatsLine2(batchTaskType, batchStats, split);
	var detailStatus = batchStats.detailStatus ? batchStats.detailStatus : '';
	if (line2) {
		return line1 + '<br>' + line2 + (detailStatus ? '<br>' + detailStatus : '');
	}
	return line1 + (detailStatus ? '<br>' + detailStatus : '');
}

var TASK_COUNTER_LABELS = {
	IMPORT_PROCESS: [
		{field: 'recordCount', label: 'Total Records In File'},
		{field: 'totalCount', label: 'Valid Records'},
		{field: 'dataCount', label: 'Lines Read'},
		{field: 'storedCount', label: 'Records Stored'},
		{field: 'filteredCount', label: 'Records Filtered'},
		{field: 'unitsCreatedCount', label: 'Units Created'}
	],
	CALCULATION: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	REPORT: [
		{field: 'totalCount', label: 'Units In Report'}
	],
	BULK_GROUP_REPORTS: [
		{field: 'dataCount', label: 'Groups Complete'},
		{field: 'totalCount', label: 'Groups Total'}
	],
	CLOSE_REPORTS: [
		{field: 'dataCount', label: 'Reports Complete'},
		{field: 'totalCount', label: 'Reports Total'}
	],
	DELETE_DATA: [
		{field: 'dataCount', label: 'Records Deleted'},
		{field: 'totalCount', label: 'Records Found'},
		{field: 'filteredCount', label: 'Skipped (Locks)'}
	],
	MATCH_UNREFERENCE_FUEL: [
		{field: 'dataCount', label: 'Matched'},
		{field: 'totalCount', label: 'Unref Fuel Total'},
		{field: 'filteredCount', label: 'Skipped (Locks)'}
	],
	ROLLBACK_IMPORT: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'},
		{field: 'filteredCount', label: 'Skipped (Locks)'}
	],
	RESTORE_DELETED_DATA: [
		{field: 'dataCount', label: 'Records Restored'},
		{field: 'filteredCount', label: 'Skipped (Locks)'}
	],
	HARD_PURGE_DELETED_DATA: [
		{field: 'dataCount', label: 'Records Purged'},
		{field: 'filteredCount', label: 'Skipped (Locks)'}
	],
	ARCHIVE: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	ARCHIVE_RESTORE: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	GPS_FILTER: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	TIME_SHIFT: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	REMOVE_TRACTORS: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	REMOVE_TRAILERS: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	REMOVE_DRIVERS: [
		{field: 'dataCount', label: 'Units Processed'},
		{field: 'totalCount', label: 'Units Total'}
	],
	FLEET_SUMMARY: [
		{field: 'dataCount', label: 'Steps Complete'},
		{field: 'totalCount', label: 'Steps Total'}
	]
};

function buildTaskStatDetailRows(batchTaskType, batchStats) {
	var rows = [];
	if (!batchStats) {
		return rows;
	}
	var fieldDefs = TASK_COUNTER_LABELS[batchTaskType];
	if (fieldDefs) {
		fieldDefs.forEach(function(def) {
			var value = statValue(batchStats, def.field);
			if (isApplicable(value)) {
				rows.push({key: def.label, value: value});
			}
		});
	} else if (!fieldDefs && usesLegacyDetail(batchStats)) {
		rows.push({key: 'Total Processed', value: statValue(batchStats, 'totalCount')});
		rows.push({key: 'Data Count', value: statValue(batchStats, 'dataCount')});
		rows.push({key: 'Record Count', value: statValue(batchStats, 'recordCount')});
		rows.push({key: 'Stored Count', value: statValue(batchStats, 'storedCount')});
		rows.push({key: 'Filtered Count', value: statValue(batchStats, 'filteredCount')});
		rows.push({key: 'Unit Created Count', value: statValue(batchStats, 'unitsCreatedCount')});
		rows = rows.filter(function(row) {
			return isApplicable(row.value);
		});
	}

	if (batchStats.metrics) {
		Object.keys(batchStats.metrics).forEach(function(metricKey) {
			var metricValue = batchStats.metrics[metricKey];
			if (isApplicable(metricValue)) {
				rows.push({
					key: METRIC_LABELS[metricKey] || metricKey,
					value: metricValue
				});
			}
		});
	}
	return rows;
}

function usesLegacyDetail(batchStats) {
	var hasMetrics = batchStats.metrics && Object.keys(batchStats.metrics).length > 0;
	return !hasMetrics;
}

export var BatchStatsDisplay = {
	formatStatsGridHtml: formatStatsGridHtml,
	formatQuickStatsLine2: formatQuickStatsLine2,
	buildTaskStatDetailRows: buildTaskStatDetailRows,
	isApplicable: isApplicable,
	statValue: statValue
};
